// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__3B08N","content":"ManualTimeModal_content__2GEsU"};